<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('staff_survey')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('create', 'survey', true)"
                          @click="openModal()"
                          v-if="$can('create_crms') && !this.$isAdmin()"
      />
    </app-page-top-section>

    <app-table
        id="survey-table"
        :options="options"
        :card-view="false"
        @reload="reloadSurveyTable"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <app-staff-survey-create-edit-modal
        v-if="isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('survey-table')"
        @cancelled="cancelled"
    />


  </div>
</template>

<script>

import StaffSurveyMixin from "../../Mixins/StaffSurveyMixin";
import {
  EMPLOYEES_PROFILE,
  GET_STAFF_SURVEYS,
  GET_STAFF_SURVEYS_RESPONSES,
  GET_SUPPORT_TICKETS
} from "../../../Config/ApiUrl";

export default {
  mixins: [StaffSurveyMixin],
  data() {
    return {
      isModalActive: false,
      selectedUrl: '',
      tickets: [],
    };
  },
  async created() {
    // let response = await axios.get("/api/support-tickets");
    // this.tickets = response.data;
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    triggerActions(row, action, active) {
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${GET_SUPPORT_TICKETS}/${row.id}`;
        this.isModalActive = true;
      }
      else if (action.key === 'view_details') {
        // let url = urlGenerator(`${GET_STAFF_SURVEYS_RESPONSES}/${row.id}`);
        let url = `${window.location.origin}/app/survey-response/lists?id=${row.id}`;
        console.log(url);
        window.location = url;
      }
      else {
        this.getAction(row, action, active)
      }

    },
  },
};
</script>
